export default {
	path: '/verifyPhoneNumber',
	getComponent(nextState, cb) {
		require.ensure(
			[],
			(require) => {
				cb(null, require('../../pc/retrieve/VerifyPhoneNumber.js').default)
			},
			'retrieve-by-mobile'
		)
	},
}



// WEBPACK FOOTER //
// ./src/routes/retrieve/verifyPhoneNumber.js